import { inject, Injectable, Provider } from '@angular/core'

import { firstValueFrom, Observable, tap } from 'rxjs'

import {
  DataQueryProps,
  Role,
  RoleRange,
  TI_CUSTOM_ROLE_ID_RANGE,
  TI_ROLE_ID_RANGE,
  UserProfile,
  UserProfileTiView,
  UserRole,
} from '@ti/contracts'
import { ListModelConfig } from '@ti/core/models/types'
import { BaseUsersModel } from '@ti/shared/user'

import { TiAdminUsersStore } from '../../common/stores'

@Injectable()
export class AdminUsersModel extends BaseUsersModel {
  protected readonly modelName = 'AdminUsersModel'
  protected readonly usersStore = inject(TiAdminUsersStore)
  protected override readonly roleIdRanges: RoleRange[] = [
    TI_ROLE_ID_RANGE,
    TI_CUSTOM_ROLE_ID_RANGE,
  ]

  protected loadPage(props: DataQueryProps): Observable<UserProfile[]> {
    return this.api.ti.user
      .listAdmin$(props)
      .pipe(tap((users) => this.usersStore.merge(undefined, users)))
  }

  protected async countAllUsers() {
    const options = { search: '' }
    return firstValueFrom(this.api.ti.user.countAdmin$(options))
  }

  protected override config(): ListModelConfig {
    return { ...super.config(), retainCacheUrl: [''] }
  }

  protected override mapUserData(
    user: UserProfileTiView,
    roles: Role[],
    roleLabels: Record<UserRole, string>,
  ) {
    return {
      ...super.mapUserData(user, roles, roleLabels),
      auditId: user.auditId ?? undefined,
    }
  }
}

export const provideAdminUsersModel = (): Provider[] => {
  return [AdminUsersModel, { provide: BaseUsersModel, useExisting: AdminUsersModel }]
}
